import { css, etiColors } from '@eti/styles';
import { Icon } from '@eti/components';
import { rowIconWrapperStyles } from '../utils/summaryStyles';
import ActionsCell from './SummaryActionsCell';
import SummaryPriceCell from './SummaryPriceCell';
import SelectedSeatCell from './SummarySelectedSeatCell';
import TravelerCell from './SummaryTravelerCell';
import SummaryPriceCellWithPriceBreakdown from './SummaryPriceCellWithPriceBreakdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  color: ${etiColors.black};
  font-size: 0.875rem;
  position: relative;
  width: 100%;

  @media (max-width: 47.9375em) {
    border-top: 1px solid #dedede;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;
  }

  & > * {
    vertical-align: middle;

    @media (min-width: 48em) {
      border-top: 1px solid #dedede;
    }
  }

  &:hover {
    background-color: #e9f5ff;
  }
`;
const iconCellStyles = css`
  ${rowIconWrapperStyles};

  @media (max-width: 47.9375em) {
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    html[dir='rtl'] & {
      left: auto;
      right: 0;
    }
  }
`;
const travelerIconStyles = css`
  fill: ${etiColors.grayScale[10]};
  height: 0.8rem;
  width: 0.8rem;

  @media (min-width: 48em) {
    height: 1.2rem;
    width: 1.2rem;
  }
`;
const SummaryTravelerRow = _ref => {
  let {
    ageType,
    boundIndex,
    carrier,
    isRyanairInTrip,
    name,
    onRemoveSeat,
    onToggleSeatSelect,
    segmentIndex,
    selectedSeat,
    travelerIndex
  } = _ref;
  return /*#__PURE__*/_jsxs("tr", {
    className: rowStyles,
    "data-testid": `seatMapSummaryTravelerRow-${travelerIndex}`,
    children: [/*#__PURE__*/_jsx("td", {
      className: iconCellStyles,
      children: /*#__PURE__*/_jsx(Icon, {
        className: travelerIconStyles,
        id: "adult-traveler"
      })
    }), /*#__PURE__*/_jsx(TravelerCell, {
      ageType: ageType,
      name: name
    }), /*#__PURE__*/_jsx(SelectedSeatCell, {
      selectedSeat: selectedSeat && selectedSeat.value
    }), isRyanairInTrip ? /*#__PURE__*/_jsx(SummaryPriceCellWithPriceBreakdown, {
      carrier: carrier,
      markup: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.markup,
      seatPrice: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.price
    }) : /*#__PURE__*/_jsx(SummaryPriceCell, {
      markup: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.markup,
      markupTooltipId: `row_${boundIndex}_${segmentIndex}_${travelerIndex}`,
      seatPrice: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.price
    }), /*#__PURE__*/_jsx(ActionsCell, {
      boundIndex: boundIndex,
      onRemoveSeat: onRemoveSeat,
      onToggleSeatSelect: onToggleSeatSelect,
      segmentIndex: segmentIndex,
      selectedSeat: selectedSeat,
      travelerIndex: travelerIndex
    })]
  });
};
export default SummaryTravelerRow;
//# sourceMappingURL=SummaryTravelerRow.js.map